const initialState = {     
      statusType: 'ALL',
	filterText: ''
}

const administratorListFiltersReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_ADMINISTRATOR_LIST_FILTERS':
                  return {
                        ...state,
                        statusType: action.filters.statusType,
                        filterText: action.filters.filterText
                  }
            case 'UPDATE_CURRENT_USER':
            case 'LOGOUT_USER':
                  return {
                        statusType: 'ALL',
                        filterText: ''
                  }
            default:
                  return state;
      }

};
export default administratorListFiltersReducer;